module.exports = __webpack_public_path__ + "img/logo.b1dd8eb0.png";